export default "__VITE_ASSET__2e52553c__"